import { getSessionStorage, setSessionStorage, StorageKey } from '@utils/StorageUtils';
import { PageType, SelectedFilters } from '@utils/pageConfig/Types';
import { Action, SideFiltersTypes } from '@state/actions/Type';

export interface SideFiltersState {
  appliedFilters: SelectedFilters[];
}

const getInitialState = () => {
  const storeFilterSettings = JSON.parse(getSessionStorage(StorageKey.SideFilters) as string);

  if (storeFilterSettings !== null) {
    return {
      appliedFilters: storeFilterSettings.appliedFilters,
    };
  }
  return Object.freeze({
    appliedFilters: [
      {
        pageType: PageType.CATEGORY_LEADERBOARD,
        selectedFilters: [],
      },
      {
        pageType: PageType.RETAILER_OVERVIEW,
        selectedFilters: [],
      },
      {
        pageType: PageType.OPPORTUNITY_REVIEW,
        selectedFilters: [],
      },
      {
        pageType: PageType.PERFORMANCE_ANALYSIS,
        selectedFilters: [],
      },
      {
        pageType: PageType.RI_PRODUCT,
        selectedFilters: [],
      },
      {
        pageType: PageType.TRADING_ASSISTANT,
        selectedFilters: [],
      },
      {
        pageType: PageType.EXPLORE,
        selectedFilters: [],
      },
    ],
  });
};

const SideFiltersReducer = (
  state: SideFiltersState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === SideFiltersTypes.SideFiltersUpdate) {
    const finalPayLoad: SideFiltersState = {
      ...state,
      appliedFilters: action.payload.appliedFilters,
    };

    setSessionStorage(StorageKey.SideFilters, JSON.stringify(finalPayLoad));
    return finalPayLoad;
  }
  return state;
};

export default SideFiltersReducer;
